import axios from 'axios';
import { API_BASE_URL } from "../helper/env";
import {
  getLocalAuthToken,
  getObjectToFormData,
} from "../helper/utils";

export const add = (url, key, data) => {
  return new Promise((resolve, reject) => {
    axios.post(API_BASE_URL + '/' + url, { [key]: data }, {
      headers: {}
    }).then(res => {
      console.log(res.data);
      if (res?.data?.error) {
        reject(res?.data?.error)
      } else {
        resolve(res.data)
      }
    })
      .catch(err => {
        reject('Something went wrong')
      })
  })
}

export const exportFile = (url, params) => {
  return new Promise((resolve, reject) => {
    axios.get(API_BASE_URL + '/' + url, {
      params,
      headers: {}
    })
      .then(res => {
        console.log(res.data);
        if (res?.data?.error) {
          reject(res?.data?.error)
        } else {
          resolve(res.data)
        }
      })
      .catch(err => {
        reject('Something went wrong')
      })
  })
}

export const update = (url, id, item, data) => {
  return new Promise((resolve, reject) => {
    axios.put(API_BASE_URL + '/' + url + '/' + id, { [item]: data }, {
      headers: {}
    }).then(res => {
      if (res?.data?.error) {
        reject(res?.data?.error)
      } else {
        resolve(res.data)
      }
    })
      .catch(err => {
        reject('Something went wrong')
      })
  });
}

export const updateDwh = (url, id, item, data) => {
  return new Promise((resolve, reject) => {
    axios.put(API_BASE_URL + '/' + url + '/' + id, { [item]: data }, {
      headers: {}
    }).then(res => {
      if (res?.data?.error) {
        reject(res?.data?.error)
      } else {
        resolve(res.data)
      }
    })
      .catch(err => {
        reject('Something went wrong')
      })
  });
}

export const getList = (url, params) => {
  const authData = getLocalAuthToken();
  return new Promise((resolve, reject) => {
    axios.get(API_BASE_URL + `/` + url, {
      params,
      headers: {
        Authorization: authData.message.token
      }
    }).then(res => {
      if (res?.data?.error) {
        reject(res?.data?.error)
      } else {
        resolve(res.data)
      }
    }).catch(err => {
      reject(err.message)
    })
  })
}

export const getData = (url, params) => {
  const authData = getLocalAuthToken();
  return new Promise((resolve, reject) => {
    axios.get(API_BASE_URL + `/` + url, {
      params,
      headers: {
        Authorization: authData.message.token
      }
    }).then(res => {
      if (res?.data?.error) {
        reject(res?.data?.error)
      } else {
        resolve(res.data)
      }
    }).catch(err => {
      reject(err.message)
    })
  })
}

export const putData = (url, data) => {
  const authData = getLocalAuthToken();
  return new Promise((resolve, reject) => {
    axios.put(API_BASE_URL + `/` + url, data, {
      headers: {
        Authorization: authData.message.token
      }
    }).then(res => {
      if (res?.data?.error) {
        reject(res?.data?.error)
      } else {
        resolve(res.data)
      }
    }).catch(err => {
      reject(err.message)
    })
  })
}

export const getLocations = url => {
  return new Promise((resolve, reject) => {
    axios.get(API_BASE_URL + `/` + url, {
      headers: {}
    }).then(res => {
      if (res?.data?.error) {
        reject(res?.data?.error)
      } else {
        resolve(res.data)
      }
    }).catch(err => {
      reject(err.message)
    })
  })
}

export const getThanas = params => {
  return new Promise((resolve, reject) => {
    axios.get(API_BASE_URL + `/thanas/search`, {
      params,
      headers: {}
    }).then(res => {
      if (res?.data?.error) {
        reject(res?.data?.error)
      } else {
        resolve(res.data)
      }
    }).catch(err => {
      reject(err.message)
    })
  })
}

export const getAreas = params => {
  return new Promise((resolve, reject) => {
    axios.get(API_BASE_URL + `/areas/search`, {
      params,
      headers: {}
    }).then(res => {
      if (res?.data?.error) {
        reject(res?.data?.error)
      } else {
        resolve(res.data)
      }
    }).catch(err => {
      reject(err.message)
    })
  })
}

export const getDetails = (url, id) => {
  return new Promise((resolve, reject) => {

    axios.get(API_BASE_URL + `/` + url + `/` + id, {
      headers: {}
    }).then(res => {
      if (res?.data?.error) {
        reject(res?.data?.error)
      } else {
        resolve(res.data)
      }
    }).catch(err => {
      reject(err.message)
    })
  })
}

export const deleteData = (url, params) => {
  return new Promise((resolve, reject) => {
    axios.delete(`${API_BASE_URL}/${url}`, {
      params,
      headers: {}
    })
      .then(res => {
        if (res?.data?.error) {
          reject(res?.data?.error)
        } else {
          resolve(res.data)
        }
      })
      .catch(err => {
        reject(err.message)
      })
  })
}

export const destroy = (url, id) => {
  return new Promise((resolve, reject) => {
    axios.delete(`${API_BASE_URL}/${url}/${id}`, {
      headers: {}
    })
      .then(res => {
        if (res?.data?.error) {
          reject(res?.data?.error)
        } else {
          resolve(res.data)
        }
      })
      .catch(err => {
        reject(err.message)
      })
  })
}

export const packCustomerOrder = (customer_order_id, item, data) => {
  return new Promise((resolve, reject) => {
    axios.put(API_BASE_URL + `/customer_orders/` + customer_order_id + `/pack`, { [item]: data }, {
      headers: {}
    }).then(res => {
      if (res?.data?.error) {
        reject(res?.data?.error)
      } else {
        resolve(res.data)
      }
    }).catch(err => {
      reject(err.message)
    })
  })
}

export const cancelCustomerOrder = (customer_order_id, data) => {
  return new Promise((resolve, reject) => {
    axios.put(API_BASE_URL + `/customer_orders/` + customer_order_id + `/cancel_order`, data, {
      headers: {}
    }).then(res => {
      if (res?.data?.error) {
        reject(res?.data?.error)
      } else {
        resolve(res.data)
      }
    }).catch(err => {
      reject(err.message)
    })
  })
}

export const unpackCustomerOrder = (customer_order_id, data) => {
  return new Promise((resolve, reject) => {
    axios.put(API_BASE_URL + `/customer_orders/` + customer_order_id + `/unpack`, data, {
      headers: {}
    }).then(res => {
      if (res?.data?.error) {
        reject(res?.data?.error)
      } else {
        resolve(res.data)
      }
    }).catch(err => {
      reject(err.message)
    })
  })
}

export const updateOrderStatus = (packedOrders, item, customer_order_id, rider_id) => {
  return new Promise((resolve, reject) => {
    axios.put(API_BASE_URL + `/customer_orders/` + customer_order_id + `/pack`,
      { packed_items: packedOrders, rider_id: rider_id }, {
      headers: {}
    }).then(res => {
      if (res?.data?.error) {
        reject(res?.data?.error)
      } else {
        resolve(res.data)
      }
    }).catch(err => {
      reject(err.message)
    })
  })
}

export const getPaginatedList = (url, params) => {
  const authData = getLocalAuthToken();
  return new Promise((resolve, reject) => {
    axios.get(API_BASE_URL + `/` + url, {
      params,
      headers: {
        Authorization: authData.message?.token
      }
    }).then(res => {
      if (res?.data?.error) {
        reject(res?.data?.error)
      } else {
        resolve(res)
      }
    }).catch(err => {
      reject(err.message)
    })
  })
}

export const updateData = (url, data) => {
  return new Promise((resolve, reject) => {
    axios.put(API_BASE_URL + '/' + url, data, {
      headers: {}
    }).then(res => {
      if (res?.data?.error) {
        reject(res?.data?.error)
      } else {
        resolve(res.data)
      }
    })
      .catch(err => {
        reject(err)
      })
  });
}

export const postData = (url, params) => {
  const authData = getLocalAuthToken();
  return new Promise((resolve, reject) => {
    axios.post(API_BASE_URL + `/` + url, params, {
      headers: {
        Authorization: authData.message.token
      }
    }).then(res => {
      if (res.data?.error) {
        reject(res?.data?.error)
      } else {
        resolve(res.data)
      }
    }).catch(err => {
      reject(err.message)
    })
  })
}
export const getLocationVariantsList = id => {
  return new Promise((resolve, reject) => {
    axios.get(API_BASE_URL + `/locations/${id}/variants`, {
      headers: {}

    }).then(res => {
      if (res.data?.error) {
        reject(res?.data?.error)
      } else {
        resolve(res.data)
      }
    }).catch(err => {
      reject(err.message)
    })
  })
}

export const assignRiderCustomerOrder = (customer_order_id, params) => {
  return new Promise((resolve, reject) => {
    axios.put(API_BASE_URL + `/customer_orders/` + customer_order_id + `/assign_rider`, params, {
      headers: {}
    }).then(res => {
      if (res?.data?.error) {
        reject(res?.data?.error)
      } else {
        resolve(res.data)
      }
    }).catch(err => {
      reject(err.message)
    })
  })
}

export const serialiseAndPost = (url, obj, data) => {
  const formData = getObjectToFormData({ [obj]: data })
  return new Promise((resolve, reject) => {
    axios.post(API_BASE_URL + '/' + url, formData, {
      headers: {}
    })
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject('Something went wrong')
      })
  })
}
export const PostCSV = (url, formData) => {
  return new Promise((resolve, reject) => {
    axios.put(API_BASE_URL + '/' + url, formData, {
      headers: {}
    })
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject('Something went wrong')
      })
  })
}

export const serializeAndUpdate = (url, obj, id, data) => {
  const formData = getObjectToFormData({ [obj]: data })
  // console.log(formData)
  return new Promise((resolve, reject) => {
    axios.put(`${API_BASE_URL}/${url}/${id}`, formData, {
      headers: {}
    })
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        console.log(err);
        reject('Something went wrong')
      })
  });
}
